import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import './forgotPassword.css';
import ApiClient from '../../Services/ApiClient';

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') ?? '';
  const [valid, setValid] = useState<boolean | null>(null);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setValid(false);
      return;
    }

    const validate = async () => {
      try {
        await ApiClient.get(`/auth/validate-reset-token?token=${encodeURIComponent(token)}`);
        setValid(true);
      } catch {
        setValid(false);
      }
    };

    validate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);

    if (!newPassword) {
      setMessage('אנא הכנס סיסמה חדשה.');
      return;
    }

    if (newPassword.length < 6) {
      setMessage('הסיסמה חייבת להכיל לפחות 6 תווים.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('הסיסמאות אינן תואמות.');
      return;
    }

    setLoading(true);
    try {
      await ApiClient.post('/auth/reset-password', { token, newPassword });
      setMessage('הסיסמה אופסה בהצלחה. מועבר לעמוד התחברות…');
      setNewPassword('');
      setConfirmPassword('');
      setTimeout(() => navigate('/login'), 1300);
    } catch (err: any) {
      const txt = err?.data?.message || err?.message || 'כשלון באיפוס הסיסמה.';
      setMessage(txt);
    } finally {
      setLoading(false);
    }
  };

  if (valid === null) {
    return <div className="forgot-password-container page-padding"><p>בודק את הקישור...</p></div>;
  }

  if (!valid) {
    return (
      <div className="forgot-password-container page-padding">
        <h2>איפוס סיסמה</h2>
        <div className="error-message">קישור לא תקין או שפג תוקפו.</div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container page-padding">
      <h2>הגדרת סיסמה חדשה</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>סיסמה חדשה:</label>
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            required
            minLength={6}
            autoFocus
          />
        </div>
        <div className="form-group">
          <label>אימות סיסמה:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            required
            minLength={6}
          />
        </div>

        {message && (
          <div className={message.includes('הצלחה') ? 'success-message' : 'error-message'}>
            {message}
          </div>
        )}

        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'מעדכן...' : 'עדכן סיסמה'}
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;